class DragScroll {
  constructor(slider) {
    if (slider.dataset.dragScrollReady) return;

    slider.dataset.dragScrollReady = 'true';
    this.slider = slider;
    this.startX = 0;
    this.startScrollLeft = 0;
    this.isDragging = false;
    this.activePointerId = null;

    slider.addEventListener('pointerdown', this.onPointerDown.bind(this));
    slider.addEventListener('pointermove', this.onPointerMove.bind(this));
    slider.addEventListener('pointerup', this.onPointerEnd.bind(this));
    slider.addEventListener('pointercancel', this.onPointerEnd.bind(this));
    slider.addEventListener('dragstart', (event) => event.preventDefault());
    slider.addEventListener('click', this.onClick.bind(this), true);
  }

  onPointerDown(event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    this.startX = event.clientX;
    this.startScrollLeft = this.slider.scrollLeft;
    this.isDragging = false;
    this.activePointerId = event.pointerId;
  }

  onPointerMove(event) {
    if (event.pointerId !== this.activePointerId) return;

    const distance = event.clientX - this.startX;
    if (!this.isDragging && Math.abs(distance) > 4) {
      this.isDragging = true;
      // Capturing the pointer retargets the click event to the slider, so the
      // card link never sees it. Capture only once a drag is real, leaving
      // plain clicks to navigate.
      this.slider.setPointerCapture(event.pointerId);
      this.slider.classList.add('is-dragging');
    }
    if (!this.isDragging) return;

    this.slider.scrollLeft = this.startScrollLeft - distance;
    event.preventDefault();
  }

  onPointerEnd(event) {
    if (event.pointerId !== this.activePointerId) return;

    this.activePointerId = null;
    this.slider.classList.remove('is-dragging');
    if (this.slider.hasPointerCapture(event.pointerId)) {
      this.slider.releasePointerCapture(event.pointerId);
    }
  }

  onClick(event) {
    if (!this.isDragging) return;

    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }
}

document.querySelectorAll('.v4-dragscroll').forEach((slider) => new DragScroll(slider));